export default {
  'basicData': {
    'lastName': '홍',
    'firstName': '길동',
    'lastNameFurigana': '',
    'firstNameFurigana': '',
    'birthYear': '',
    'birthMonth': '',
    'birthDay': '',
    'sex': '',
    'postNumber': '',
    'address1': '',
    'address2': '',
    'addressFurigana': '',
    'tel1': '',
    'tel2': '',
    'tel3': '',
    'email': '',
    'idPhotoSrc': '/kr/resume/static/img/id-photo-sample.jpg',
    'useContact': '',
    'contactPostNumber': '',
    'contactAddress1': '',
    'contactAddress2': '',
    'contactAddressFurigana': '',
    'contactCareOf': '',
    'contactTel1': '',
    'contactTel2': '',
    'contactTel3': '',
    'contactMobile': '',
    'contactFax': '',
    'contactEmail': '',
    'updateDate': ''
  },
  'formatData': {
    'createDate': new Date(),
    'occupation': 'engineer',
    'jobSummary': '대학을 졸업한 후 관광목장에 입사.목장 업무에 담당.첫번째회사에서는  xx을 x년 담당 후, 리더로서 프로젝트의 진척 관리를 담당함. 두번째 회사에서는, 덧붙여 고객 고충상담경험을함',
    'experienceAndKnowledge': '',
    'skillsToUse': [
      {
        'skillname': '제초',
        'years': '3',
        'description': '비수기에도 개인적으로 임하고 있습니다.',
        'uuid': 'd9404372-8982-4324-81a4-f5b4975454d9'
      },
      {
        'skillname': 'xx자격증',
        'years': '5',
        'description': '20xx년x월 취득',
        'uuid': '3ba4331c-40bf-4ebc-bc5d-dc7259566fa9'
      }
    ],
    'jobHistories': [
      {
        'companyName': '주식회사◯◯◯◯',
        'startYear': '2021',
        'startMonth': '4',
        'endYear': '',
        'endMonth': '',
        'isContinuing': true,
        'capitalStock': 'xxxx',
        'numberOfEmployees': '30',
        'businessArea': '이력서 서비스 운영진',
        'projects': [
          {
            'projectTitle': '이력서 서비스 운영스탭',
            'startYear': '2022',
            'startMonth': '4',
            'endYear': '2023',
            'endMonth': '8',
            'contentsOfProject': '브라우저로 이력서를 만드는 WEB 서비스 「yagish(야기슈)」운영',
            'envAndScale': '',
            'position': '사원',
            'uuid': '9b6ccada-f15f-496b-86ad-1b80d582fc41'
          }
        ],
        'uuid': '579264f3-1d0c-4dea-97ae-39ee13b93238'
      },
      {
        'companyName': '〇△회사',
        'startYear': '2013',
        'startMonth': '4',
        'endYear': '2016',
        'endMonth': '4',
        'capitalStock': 'xxxx',
        'numberOfEmployees': '20',
        'businessArea': '자연과 만나는 관광낙농목장 운영',
        'projects': [
          {
            'projectTitle': '목초지의 제초',
            'startYear': '2013',
            'startMonth': '04',
            'endYear': '2016',
            'endMonth': '04',
            'contentsOfProject': '목장 내 제초 및 급경사 지역의 풀베기에서 목표 이상의 성과를 올려 대폭적인 비용 절감을 실현했습니다.',
            'envAndScale': '',
            'position': '',
            'uuid': '61a94659-0813-4994-8a55-3ed81685c1b5'
          },
          {
            'projectTitle': '목장의 경비',
            'startYear': '2013',
            'startMonth': '04',
            'endYear': '2016',
            'endMonth': '04',
            'contentsOfProject': '목장 내 감시. 팀의 리더를 담당.야생동물의 침입이나 쓰레기의 불법 투기의 제로 실현',
            'envAndScale': '',
            'position': '',
            'uuid': 'a56e2c84-9594-4990-987b-21c4c584edd0'
          }
        ],
        'uuid': 'c1eb921c-6263-4321-a922-f4eb86326c59'
      }
    ],
    'licenseHistories': [],
    'prMessage': '방문객수의 증가를 목적으로 한 목장 업무에 종사했습니다.장기간에 걸친 제초 프로젝트였기 때문에, 자신의 성과가 실제의 방문객수로 연결되고 있는 것을 실감할 수 있어 매우 보람을 느낄 수 있었습니다.\n' +
      '또한 리더로서의 경험으로 팀을 이끌고 성과를 극대화시키는 기쁨을 알게 되었고, 보다 난이도 높은 프로젝트에 도전하고 싶은 마음이 높아졌습니다.\n' +
      '항상 유저를 의식해, 보다 많은 유저가 사용할 수 있는 서비스 만들기에 공헌해 가고 싶다고 생각하고 있습니다.'
  }
}
